const WORKOUT_SECTIONS_DOMAIN = 'workoutSections'

export default WORKOUT_SECTIONS_DOMAIN
